import React, { useState } from 'react';
import classNames from 'classnames';
import { isDesktop } from 'react-device-detect';
import Button from '@/common/components/button';
import CollapseDetail from '@/common/components/collapse';
import Text from '@/common/components/text';
import ArrowDownIcon from '~/public/assets/images/svg/arrow-down.svg';

interface Props {
  description: string;
  isCollapsable: boolean;
}

function ProductDetail({ description, isCollapsable }: Props) {
  const [showMore, setShowMore] = useState(false);
  const sanitizeHTML = (html: string) => {
    return html?.replace(/<script.*?>.*?<\/script>/gi, '');
  };
  const sanitizedHtmlToRender = sanitizeHTML(description);

  const renderDesktopDetail = () => (
    <div className="flex flex-col items-start gap-3 rounded-2xl bg-white px-5 py-4">
      <Text className="!text-sm !font-semibold text-secondary-400">
        جزئیات محصول
      </Text>
      <div className="relative">
        <p
          className={classNames(
            'text-xs transition-[max-height] duration-200 [&_b]:text-sm [&_h3]:text-sm [&_h3]:font-semibold',
            isCollapsable && !showMore
              ? 'max-h-[102px] overflow-hidden bg-gradient-to-t from-white to-transparent'
              : 'max-h-[1000px]'
          )}
          dangerouslySetInnerHTML={{
            __html: sanitizedHtmlToRender,
          }}
        ></p>
        {isCollapsable && !showMore ? (
          <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent" />
        ) : null}
      </div>
      {isCollapsable ? (
        <Button
          type="link"
          onClick={() => {
            setShowMore((prev) => !prev);
          }}
          className="!z-0"
          icon={
            <ArrowDownIcon
              className={classNames(
                'transition-transform duration-200',
                showMore ? 'rotate-180' : ''
              )}
            />
          }
          iconPosition="end"
        >
          {showMore ? 'نمایش کمتر' : 'نمایش بیشتر'}
        </Button>
      ) : null}
    </div>
  );

  const renderMobileDetail = () => (
    <CollapseDetail
      className=""
      panelClassName="text-xs font-medium text-secondary-300"
      panelHeader="جزئیات محصول"
    >
      <p
        className={classNames(
          'text-xs transition-[max-height] duration-200 [&_b]:text-sm [&_h3]:text-sm [&_h3]:font-semibold'
        )}
        dangerouslySetInnerHTML={{
          __html: sanitizedHtmlToRender,
        }}
      ></p>
    </CollapseDetail>
  );

  return isDesktop ? renderDesktopDetail() : renderMobileDetail();
}

export default ProductDetail;
